export default [
  {
    text: "Data",
    icon: "email",
    items: [
      {
        text: "Insights",
        path: "/insights",
        icon: "sparkle",
      },
      {
        text: "Tags",
        path: "/tags",
        icon: "smalliconslayout",
      },
      {
        text: "Knowledge Base",
        path: "/emailkb",
        icon: "hierarchy",
      },
      {
        text: "Sync Emails",
        path: "/sync",
        icon: "refresh"
      },
      {
        text: "AI Tags",
        path: "/aitags",
        icon: "globe"
      }
    ]
  }
  ];
